import { GridColumns, GridValueGetterParams } from '@mui/x-data-grid-pro';
import { InvestidorInstrumentoFinanceiroResponse } from 'common/genericTypes';
import moment from 'moment';

export const getTitularidadeGridColumns = (): GridColumns => [
    {
        field: 'codigo',
        headerName: 'Código do Instrumento',
        valueGetter: (params: GridValueGetterParams<InvestidorInstrumentoFinanceiroResponse>) =>
            params.row.codigo,
        minWidth: 130,
        maxWidth: 180,
        flex: 1,
        resizable: true,
    },
    {
        field: 'tipo',
        headerName: 'Tipo de Instrumento',
        valueGetter: (params: GridValueGetterParams<InvestidorInstrumentoFinanceiroResponse>) =>
            params.row.tipo,
        minWidth: 150,
        width: 150,
        flex: 1,
        resizable: true,
    },
    {
        field: 'razaoSocialEmissor',
        headerName: 'Emissor',
        valueGetter: (params: GridValueGetterParams<InvestidorInstrumentoFinanceiroResponse>) =>
            params.row.razaoSocialEmissor,
        minWidth: 150,
        width: 150,
        flex: 0.8,
        resizable: true,
    },
    {
        field: 'dataDaEmissao',
        headerName: 'Data da Emissão',
        valueGetter: (params: GridValueGetterParams<InvestidorInstrumentoFinanceiroResponse>) => {
            const dataCriacao = moment(params.row.dataDaEmissao);
            return dataCriacao.isValid() ? dataCriacao.format('DD/MM/YYYY') : 'Data inválida';
        },
        width: 100,
        maxWidth: 150,
        flex: 1,
        resizable: true,
    },
    {
        field: 'valorDeEmissao',
        headerName: 'Valor da Emissão',
        valueGetter: (params: GridValueGetterParams<InvestidorInstrumentoFinanceiroResponse>) =>
            params.row.valorDeEmissao,
        minWidth: 100,
        width: 100,
        flex: 1,
        resizable: true,
    },
    {
        field: 'razoesSociaisCustodiantes',
        headerName: 'Custodiante*',
        valueGetter: (params: GridValueGetterParams<InvestidorInstrumentoFinanceiroResponse>) =>
            params.row.razoesSociaisCustodiantes,
        minWidth: 150,
        width: 150,
        flex: 1,
        resizable: true,
    },
];